import React, { Component } from 'react';
// import "./home.css"
import TimeAgo from 'react-timeago'
import date from 'date-and-time';
import Moment from 'react-moment'

class Show extends Component {
    constructor(props){
        super(props)
        this.state={
            isEdit: false,
            message:"",
            alertDelete:false

        }
    }

  componentDidMount(){
      this.setState({
        message: this.props.message
      })
  }

  checkUnred=(data)=>{
    console.log("read----==--->",data) 
        if(data === true){
            console.log("read----==---> yes",data) 
        }else{
            console.log("read----==---> no",data)
        }
  }

    editNews =(event)=>{
        event.preventDefault();

            const data ={
                body:this.body.value,
                title:this.title.value,
                type :this.type.value,
                created_by : this.props.id,
            }
            this.props.editNews(data)
            this.setState({isEdit:false})
    }

    onDelete = ()=> {
        const {onDelete , id} = this.props
        console.log("id", id)
        onDelete(id)
    }
    
    
  render() {
    // var divStyle = {
    //     color: 'white',
    //     background: "red",
    //     height:"auto",
    //     WebkitTransition: 'all', // note the capital 'W' here
    //     "margin-top":"110px"
        
    //   };
    
  console.log(this.props.title)

    return (
        <div class="">
            <a onClick={this.onDelete}>
            <i class="fas fa-trash-alt notice-trash-del" style={{float:"right"}}></i>
            </a>  
        
            <ul class="user-list">
                <li>
                    <div class="user-list-avatar">
                        {
                            this.props.user.profile_image_url ? 
                            <img src={ this.props.user.profile_image_url} alt=""/>
                            :
                            <i class="far fa-user" style={{fontSize:"125%"}}></i>
                        }
                        
                    </div>
                
                    <div class="user-list-info">
                        <div class="name is-4">{this.props.user.first_name}</div>
                        <div class="position">
                        <span class="sender-email">{this.props.user.email}</span>
                             
                               
                         
                        </div>
                    </div>
                   
                </li>
            </ul>
            
        </div>

    )

}





}

export default Show;


// WEBPACK FOOTER //
// ./src/component/school/show.js